import { render, staticRenderFns } from "./SystemComponentsHierarchies.vue?vue&type=template&id=606b8338&"
import script from "./SystemComponentsHierarchies.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports